import { Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren } from "@angular/core";
import { BranchMatserService } from "app/masters/branch-matser.service";
import { map, startWith, takeUntil } from "rxjs/operators";
import { LocationService } from "app/masters/location-master/location.service";
import { Observable, Subject } from "rxjs";
import { FormControl } from "@angular/forms";
import { MatTableDataSource } from "@angular/material/table";
import { billseriesModal, billcodeModal } from "app/masters/models/service-master.model";
import { AuthService } from "app/auth/auth.service";
import { MatInput } from '@angular/material/input'; 
import { ChangeDetectorRef } from '@angular/core';



@Component({
  selector: "app-bill-series-master",
  templateUrl: "./bill-series-master.component.html",
  styleUrls: ["./bill-series-master.component.scss"],
})
export class BillSeriesMasterComponent implements OnInit {
  destroybillSeries$: Subject<boolean> = new Subject<boolean>();
  billactiveArray: any[] = [];
  billseriesactiveArray:any[] = [];
  billtypeControl: FormControl;
  filteredbilltypeArray: Observable<any[]>;
  dataSource = new MatTableDataSource<any>();
  displayedColumns: string[] = [
    "BillSeriesName",
    "BillSeriesCode",
    "BillHeaderName",
    "BillTypeName",
    "IsActive",
  ];
  searchValue: string;
  billseriesData: billseriesModal = {};
  holdbillData: any;
  billSeriesList$: Observable<any[]>; 
  filteredbranchArray: Observable<any[]>;
  filteredbillseriesArray:Observable<any[]>;
  branchList: any[] = [];
  branchlistControl: FormControl;
  companyControl: FormControl;
  billseriesControl:FormControl;
  companyList: any[] = [];
  filteredcompanyArray: Observable<any[]>;
  selectedbranchId: any;
  selectedCompanyId: any;
  billData: billcodeModal [] = [];
  @ViewChildren(MatInput) matInputs: QueryList<MatInput>; 
  isButtonEnabled: boolean = false;  


  constructor(
    private branchmasterService: BranchMatserService,
    private LocationService: LocationService,
    private authService: AuthService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.getbilltypeData(0);
    this.dataSource.filterPredicate = this.createFilter();
    this.getbillseriesMaster(0);
    this.getBranch()
    this.getCompany()
  }
  openbillseriesModal() {
    document.getElementById("billseriesModal").style.display = "block";
    this.getbillseriesMaster(0);
  }

  closebillseriesModal() {
    document.getElementById("billseriesModal").style.display = "none";
    this.searchValue = "";
    this.dataSource.filter = "";
  }
  openrelationModal() {
    document.getElementById("relationModal").style.display = "block";
    this.billData = []
    this.selectedbranchId = null
    this.selectedCompanyId = null
    this.branchlistControl.reset();
    this.companyControl.reset();
    this.isButtonEnabled = false;
  }

  closerelationModal() {
    document.getElementById("relationModal").style.display = "none";
  }

  getbilltypeData(id: number) {
    this.LocationService.GetBillingTypeMaster(id)
      .pipe(takeUntil(this.destroybillSeries$))
      .subscribe(
        (item: any[]) => {
          this.billactiveArray = item.filter((x: any) => x.isActive === true);
          this.initializebilltypeControl();
        },
        (err) => {
          console.error("Error fetching service data:", err);
        }
      );
  }

  initializebilltypeControl() {
    this.billtypeControl = new FormControl();
    this.filteredbilltypeArray = this.billtypeControl.valueChanges.pipe(
      startWith(""),
      map((bill) =>
        bill ? this.filterbilltypeFun(bill) : this.billactiveArray.slice()
      )
    );
  }

  filterbilltypeFun(name: string): any[] {
    return this.billactiveArray.filter((bill) =>
      bill.billTypeName.toLowerCase().includes(name.toLowerCase())
    );
  }

  getbillseriesMaster(id: number) {
    this.billSeriesList$ = this.LocationService.getbillseriesMaster(id).pipe(
      takeUntil(this.destroybillSeries$) 
    );
  
    this.billSeriesList$.subscribe(
      (data: any[]) => {
        this.dataSource.data = data;
        this.billseriesactiveArray=data.filter((x: any) => x.isActive === true);
        this.initilaizebillseriesnameControl()
        
      },
        (err) => {
          if (err.status == 403) {
            this.LocationService.openSnackBar(
              "You Don't have Permission",
              "OK"
            );
          } else if (err.error.statusCode == 422) {
            this.LocationService.openSnackBar(err.error.message, "OK");
          } else {
            this.LocationService.openSnackBar("API Failed", "OK");
          }
        }
      );
  }

  initilaizebillseriesnameControl(){
    this.billseriesControl = new FormControl();
    this.filteredbillseriesArray = this.billseriesControl.valueChanges.pipe(
      startWith(""),
      map((bill) =>
        bill ? this.filterbillseriesFun(bill) : this.billseriesactiveArray.slice()
      )
    );
  }

  filterbillseriesFun(name: string): any[] {
    return this.billseriesactiveArray.filter((bill) =>
      bill.billTypeName.toLowerCase().includes(name.toLowerCase())
    );
  }
  applybillseriesFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  createFilter(): (data: any, filter: string) => boolean {
    return (data, filter): boolean => {
      const transformedFilter = filter.trim().toLowerCase();
      return (
        data.billSerieseName?.toLowerCase().includes(transformedFilter) ||
        data.billSerieseCode?.toLowerCase().includes(transformedFilter) ||
        data.billHeaderName?.toLowerCase().includes(transformedFilter) ||
        data.billTypeName?.toLowerCase().includes(transformedFilter) ||
        (data.isActive ? "active" : "inactive").includes(transformedFilter)
      );
    };
  }

  savebillseriesMaster() {
    if (this.billseriesData.billTypeName == "" || !this.billseriesData.billTypeName) {
      this.LocationService.openSnackBar("Bill Type Name is required", "OK");
      return;
    }
    const selectedbillType = this.billactiveArray.find(
      (bill) => bill.billTypeName.trim()  == this.billseriesData.billTypeName.trim()
    );
  
    if (!selectedbillType) {
      this.LocationService.openSnackBar("Please select a valid bill type data", "OK");
      return;
    } 
    if (!this.billseriesData.PK_BillSerieseId) {
      const existingbillseries = this.dataSource.data.find(
        (bill) => bill.billSerieseName.toLowerCase() === this.billseriesData.billSerieseName?.toLowerCase());
      if (existingbillseries) {
        this.LocationService.openSnackBar('Already exists in the list', 'OK');
        this.clearForm();
        return;
      }
      const payload = {
        "InsertBillSeriesMasterDto": {
          "PK_BillSerieseId": this.billseriesData.PK_BillSerieseId ? this.billseriesData.PK_BillSerieseId : 0,
          "BillSerieseName": this.billseriesData.billSerieseName,
          "BillSerieseCode": this.billseriesData.billSerieseCode,
          "IsActive": this.billseriesData.isActive ? this.billseriesData.isActive : false,
          "FK_BillTypeId": this.billseriesData.fK_BillTypeId,
          "AccountName": this.billseriesData.AccountName,
          "SACNO": this.billseriesData.SACNO,
          "IsIPD": this.billseriesData.IsIPD,
          "BillHeaderName": this.billseriesData.BillHeaderName,
          "IsEdit": false,
        },
      };

      this.LocationService.InsertbillseriesMaster(payload).pipe(takeUntil(this.destroybillSeries$)).subscribe(
        (response: any) => {
          this.LocationService.openSnackBar('Record saved successfully', 'OK');
          this.clearForm();
          this.searchValue = ''
          this.getbillseriesMaster(0)
        },
        err => {
          if (err.status == 403) {
            this.LocationService.openSnackBar("You Don't have Permission", "OK");
          }
          else if (err.error.statusCode == 422) {
            this.LocationService.openSnackBar(err.error.message, "OK");
          }
          else {
            this.LocationService.openSnackBar("API Failed", "OK");
          }
          this.searchValue = ''
        }
      );
    } else {
      const payload = {
        "InsertBillSeriesMasterDto": {
          "PK_BillSerieseId": this.billseriesData.PK_BillSerieseId ? this.billseriesData.PK_BillSerieseId : 0,
          "BillSerieseName": this.billseriesData.billSerieseName,
          "BillSerieseCode": this.billseriesData.billSerieseCode,
          "IsActive": this.billseriesData.isActive ? this.billseriesData.isActive : false,
          "FK_BillTypeId": this.billseriesData.fK_BillTypeId,
          "AccountName": this.billseriesData.AccountName,
          "SACNO":null,
          "IsIPD": this.billseriesData.IsIPD,
          "BillHeaderName": this.billseriesData.BillHeaderName,
          "IsEdit": true,
        },
      };

      this.LocationService.InsertbillseriesMaster(payload).pipe(takeUntil(this.destroybillSeries$)).subscribe(
        (response: any) => {
         if(response.statusCode ==1){
          this.LocationService.openSnackBar('Record updated successfully', 'OK');
          this.clearForm();
          this.searchValue = ''
          this.getbillseriesMaster(0)
         }else if(response.statusCode ==10){
          this.LocationService.openSnackBar('Alreday exists in the list', 'OK');
          this.clearForm();
          return;
         }
        },
        err => {
          if (err.status == 403) {
            this.LocationService.openSnackBar("You Don't have Permission", "OK");
          }
          else if (err.error.statusCode == 422) {
            this.LocationService.openSnackBar(err.error.message, "OK");
          }
          else {
            this.LocationService.openSnackBar("API Failed", "OK");
          }
          this.searchValue = ''
        }
      );
    }
  }

  clearForm() {
    this.billseriesData = {
      PK_BillSerieseId: 0,
      billSerieseName: '',
      billSerieseCode: '',
      isActive: false,
      fK_BillTypeId: 0,
      AccountName: null,
      SACNO: 0,
      IsIPD: false,
      BillHeaderName: '',
      IsEditor: false,
      billTypeName:''
    };  
  }
  onbilltypeSelected(id :any){
    const selectedBillType = this.billactiveArray.find(b => b.pK_BillTypeId == id);
    if (selectedBillType) {
      this.billseriesData.fK_BillTypeId = selectedBillType.pK_BillTypeId;
      this.billseriesData.billTypeName = selectedBillType.billTypeName;
    }
  }

  onRowDoubleClick(row){
    this.billseriesData.PK_BillSerieseId = row.pK_BillSerieseId,
    this.billseriesData.billSerieseName = row.billSerieseName,
    this.billseriesData.billSerieseCode= row.billSerieseCode,
    this.billseriesData.isActive= row.isActive,
    this.billseriesData.fK_BillTypeId= row.fK_BillTypeId,
    this.billseriesData.AccountName= row.accountName,
    this.billseriesData.SACNO= row.sacno,
    this.billseriesData.IsIPD= row.isIPD,
    this.billseriesData.BillHeaderName = row.billHeaderName,
    this.billseriesData.billTypeName=row.billTypeName
    this.closebillseriesModal()
  }

  getBranch() {
    this.LocationService.getallBranches().subscribe((branch: any[]) => {
      this.branchList = branch;
      this.initializebranchControl();
    });
  }
getCompany(){
    this.companyList = this.authService.Companies;
    this.initializecompanyControl();  
}
  initializebranchControl() {
    this.branchlistControl = new FormControl();
    this.filteredbranchArray = this.branchlistControl.valueChanges.pipe(
      startWith(''),
      map((branchList) =>
        branchList
          ? this.filterbranchlistFunction(branchList)
          : this.branchList.slice()
      )
    );
  }
  initializecompanyControl(){
    this.companyControl = new FormControl();
    this.filteredcompanyArray = this.companyControl.valueChanges.pipe(
      startWith(''),
      map((companyList) =>
        companyList
          ? this.filtercompanyFunction(companyList)
          : this.companyList.slice()
      )
    );

  }

  filterbranchlistFunction(name: string): any[] {
    return this.branchList.filter((b) =>
      b.branchName.toLowerCase().includes(name.toLowerCase())
    );
  }

 filtercompanyFunction(name: string): any[] {
  return this.companyList.filter((c) =>
    c.billingCompany.toLowerCase().includes(name.toLowerCase())
  );
}
onbranchSelected(branch){
  const selectedBranch = this.branchList.find((b: any) => b.branchName == branch);
    if (selectedBranch) {
      this.selectedbranchId = selectedBranch.pkBranchId;
    }
}
oncompanySelected(company){
  const selectedCompany = this.companyList.find((company: any) => company.companyName);
  if (selectedCompany) {
    this.selectedCompanyId = selectedCompany.pkCompanyId;
  }
  this.getbillseriesname(this.selectedbranchId,this.selectedCompanyId)
}
getbillseriesname(branch , company){
  this.LocationService.GetBillSeriesRelationMasterByBranchIdByCompanyId(branch , company)
  .pipe(takeUntil(this.destroybillSeries$))
  .subscribe(
    (item: any[]) => {
      this.billData = item
      this.billData.map(item =>(
        {
          ...item,
          IsEdit:true,
          IsDelete:false
        }
      ))
    },
    (err) => {
      console.error("API Failed", err);
    }
  );
}
addNewBillRow() {
  if (!this.selectedbranchId) {
    this.LocationService.openSnackBar('Please select a Branch', 'OK');
    return;
  }
  if (!this.selectedCompanyId) {
    this.LocationService.openSnackBar('Please select a Company', 'OK');
    return;
  }
  if (this.billData.length > 0) {
    const lastRow = this.billData[this.billData.length - 1];
    if (!lastRow.billSerieseName.trim() || !lastRow.billSerieseCode.trim()) {
      this.LocationService.openSnackBar('Please fill the last row before adding a new one', 'OK');
      return;
    }
  }

  const emptyBillRow = {
    billSerieseName: '',
    billSerieseCode: '',
    IsEdit: true ,
    IsDelete:false,
    PK_TranId:0,
    FK_BillingCompanyId:this.selectedCompanyId,
    FK_BranchId:this.selectedbranchId,
    FK_BillSeriseId:null
  };
  if (this.billData == undefined || this.billData == null || this.billData.length == 0) {
    this.billData = [emptyBillRow];
  } else {
    this.billData.push(emptyBillRow); 
  }
  this.isButtonEnabled = true;
  setTimeout(() => {
   this.focusFirstEditableInput();
  }, 0);
}
focusFirstEditableInput() {
  const firstEditableInput = this.matInputs.toArray()[this.matInputs.length - 1]; 
  if (firstEditableInput) {
    firstEditableInput.focus();
  }
}

editData(index: number, type: number) {
  if (type === 1) {
    this.filteredbillseriesArray.subscribe((billSeriesList) => {
      const selectedBillSeriesId = this.billData[index].fK_BillSeriseId;
      const isValid = billSeriesList.some(
        (option) => option.pK_BillSerieseId == selectedBillSeriesId
      );

      if (!isValid) {
        this.LocationService.openSnackBar('Please select a valid Bill Type', 'OK');
        return;
      }
    })
  }
  this.billData[index].IsEdit = type == 0 ? true : false;
  if(type == 0){
    this.isButtonEnabled = true;
  }
}

onBillSeriesSelected(event: any, index: number, selectedOption: any) {
  if (event.isUserInput) {
    const isDuplicate = this.billData.some((bill, i) => 
      i !== index && 
      bill.billSerieseName?.toLowerCase() === selectedOption.billSerieseName.toLowerCase() &&
      bill.billSerieseCode?.toLowerCase() === selectedOption.billSerieseCode.toLowerCase()
    );
    if (isDuplicate) {
      this.LocationService.openSnackBar('Already exists in the list', 'OK');
      this.billData[index].billSerieseName = '';
      this.billData[index].billSerieseCode = "";
      this.billData[index].fK_BillSeriseId = null;
      this.billData[index] = {
        billSerieseName: '',
        billSerieseCode: '',
        IsEdit:true
      };      
      return
    } else {
      this.billData[index].billSerieseName = selectedOption.billSerieseName;
      this.billData[index].billSerieseCode = selectedOption.billSerieseCode;
      this.billData[index].fK_BillSeriseId = selectedOption.pK_BillSerieseId;
    }
  }
}

saveBillingSeries(event){
    const button = (event.srcElement.disabled === undefined) ? event.srcElement.parentElement : event.srcElement;
    button.setAttribute('disabled', true);
    setTimeout(function () {
      button.removeAttribute('disabled');
    }, 2000);
    
  const invalidBills = this.billData.filter(
    bill => !bill.billSerieseName?.trim() || !bill.billSerieseCode?.trim()
  );

  if (invalidBills.length > 0) {
    this.LocationService.openSnackBar('Blank data is not allowed', 'OK');
    return;
  }
  const validbillData = this.billData
  .filter(bill => bill.billSerieseName?.trim() && bill.billSerieseCode?.trim())
  .filter((bill, index, self) => 
    index == self.findIndex(b => 
      b.billSerieseName.toLowerCase() == bill.billSerieseName.toLowerCase() && 
      b.billSerieseCode.toLowerCase() == bill.billSerieseCode.toLowerCase()
    )
  );
  var billdataArray =[]
validbillData.forEach((bill) => {
  let payload =  {
    "PK_TranId":bill.pK_TranId > 0 ?bill.pK_TranId:0,
    "FK_BillSeriseId": bill.fK_BillSeriseId,
    "FK_BranchId": this.selectedbranchId,
    "FK_BillingCompanyId": this.selectedCompanyId,
    "IsEdit": bill.pK_TranId > 0 ?true:false,
    "IsDelete": false
}
billdataArray.push(payload)
});
  const data = {
    InsertBillSeriesRelationMasterDto:billdataArray
  }
  const isfirstrecordEdit =data.InsertBillSeriesRelationMasterDto[0]?.IsEdit
  this.LocationService.InsertBillingSeriesRelationMaster(data).subscribe((response:any)=>{
    if(response.statusCode ==1 ){
      if(isfirstrecordEdit){
        this.LocationService.openSnackBar('Record updated successfully', 'OK');
      }else{
        this.LocationService.openSnackBar('Record saved successfully', 'OK');
      }
      this.getbillseriesname(this.selectedbranchId,this.selectedCompanyId)
    }
    else if(response.statusCode == 10){
      this.LocationService.openSnackBar('Already exists in the list', 'OK');
    }
    this.isButtonEnabled = false;
  },
  (err) => {
    if (err.status == 403) {
      this.LocationService.openSnackBar("You Don't have Permission", "OK");
    } 
    else if(err.error.statusCode == 422){
      this.LocationService.openSnackBar(err.error.message,"OK");
    }
    else {
      this.LocationService.openSnackBar("API Failed", "OK");
    }
    this.isButtonEnabled = false;
  })
}

oninputClear(event: any, type: string) {
  if (event.target.value.trim() === "") {
    this.billData = []; 

    if (type === "branch") {
      this.selectedbranchId = null;
    } else if (type === "company") {
      this.selectedCompanyId = null;
    }
  }
}

removeRow(row , i){
if (row.PK_TranId == 0) {
    this.billData.splice(i, 1);
    this.LocationService.openSnackBar("Record Deleted Successfully", "OK");
}else{
  const payload = {
    InsertBillSeriesRelationMasterDto: [
      {
        pK_TranId: row.pK_TranId,
        fK_BillSeriseId: row.fK_BillSeriseId,
        fK_BranchId: row.fK_BranchId,
        fK_BillingCompanyId: row.fK_BillingCompanyId,
        IsEdit: true,
        IsDelete: true
      }
    ]
  };
  this.LocationService.InsertBillingSeriesRelationMaster(payload).subscribe((response:any)=>{
    if(response.statusCode ==1 ){
        this.LocationService.openSnackBar('Record deleted successfully', 'OK');
        this.getbillseriesname(this.selectedbranchId,this.selectedCompanyId)
    }
  },
  (err) => {
    if (err.status == 403) {
      this.LocationService.openSnackBar("You Don't have Permission", "OK");
    } 
    else if(err.error.statusCode == 422){
      this.LocationService.openSnackBar(err.error.message,"OK");
    }
    else {
      this.LocationService.openSnackBar("API Failed", "OK");
    }
  })

}
}


  ngOnDestroy() {
    this.destroybillSeries$.next(true);
    this.destroybillSeries$.unsubscribe();
    this.billactiveArray = null;
    this.billtypeControl = null;
    this.filteredbilltypeArray = null;
    this.dataSource = null;
    this.searchValue = null;
    this.billseriesData = null;
    this.holdbillData = null;
  }
}
